import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","line-height":"40px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","color":"red"} }

import { reactive, ref } from 'vue';
import {pcaTextArr} from "element-china-area-data";
import {ElButton, ElMessage} from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const form = reactive({
  userAddress: '',
  year: '',
  month: '',
  wages: '',
  reason: '',
  money: '',
})

const checked = reactive({
  checked1: false,
  checked2: false,
  checked3: false,
  checked4: false,
  checked5: false,
  checked6: false,
  checked7: false,
  checked8: false,
})

const onSubmit = () => {
  if (!form.userAddress){
    ElMessage({
      message: '请选择所在地区',
      type: 'error',
    })
    return;
  }
  if (!form.year && !form.month) {
    ElMessage({
      message: '请填写工作年限',
      type: 'error',
    })
    return;
  }
  if (!form.wages) {
    ElMessage({
      message: '请填写月平均薪酬',
      type: 'error',
    })
    return;
  }
  if (!checked.checked1 && !checked.checked2 && !checked.checked3 && !checked.checked4 && !checked.checked5 && !checked.checked6 && !checked.checked7 && !checked.checked8){
    ElMessage({
      message: '请选择离职原因',
      type: 'error',
    })
    return;
  }
  if (!Number.isInteger(Number(form.year)) || form.year < 0){
    ElMessage({
      message: '请填写正确工作年数',
      type: 'error',
    })
    return;
  }
  if (!Number.isInteger(Number(form.month)) || form.month >= 12 || form.month < 0){
    ElMessage({
      message: '请填写正确工作月数',
      type: 'error',
    })
    return;
  }

  //补偿金 = a * b
  //a
  let a = form.wages;
  //b
  let date = Number(form.year) * 12 + Number(form.month);
  console.log('date', date)
  let b = 0;
  switch (true){
    case date < 6:
      b = 0.5;
      break;
    case 6 <= date && date < 12:
      b = 1;
      break;
    case 12 <= date && date < 18:
      b = 1.5;
      break;
    case 18 <= date && date < 24:
      b = 2;
      break;
    case 24 <= date && date < 30:
      b = 2.5;
      break;
    case 30 <= date && date < 36:
      b = 3;
      break;
    case 36 <= date && date < 42:
      b = 3.5;
      break;
    case 42 <= date && date < 48:
      b = 4;
      break;
    case 48 <= date && date < 54:
      b = 4.5;
      break
    case 54 <= date && date < 60:
      b = 5;
      break;
    case 60 <= date && date < 66:
      b = 5.5;
      break;
    case 66 <= date && date < 72:
      b = 6;
      break;
    case 72 <= date && date < 78:
      b = 6.5;
      break;
    case 78 <= date && date < 84:
      b = 7;
      break;
    case 84 <= date && date < 90:
      b = 7.5;
      break;
    case 90 <= date && date < 96:
      b = 8;
      break;
    case 96 <= date && date <102:
      b = 8.5;
      break;
    case 102 <= date && date <108:
      b = 9;
      break;
    case 108 <= date && date <114:
      b = 9.5;
      break;
    case 114 <= date && date <120:
      b = 10;
      break;
    case 120 <= date && date <126:
      b = 10.5;
      break;
    case 126 <= date && date <132:
      b = 11;
      break;
    case 132 <= date && date <138:
      b = 11.5;
      break;
    case 138 <= date:
      b = 12;
      break;
    default:

      break;
  }

  console.log('a', a);
  console.log('b', b);

  console.log('补偿金', a * b);
  if (checked.checked1) {
    let cappedDate = date >= 11 ? 11 : date;
    if (checked.checked5 || checked.checked7) {
      form.money = parseFloat((a * b * 2 + cappedDate * a).toFixed(2));
    } else {
      form.money = parseFloat((a * b + cappedDate * a).toFixed(2));
    }
    return;
  }

  if (checked.checked5 || checked.checked7) {
    form.money = parseFloat((a * b * 2).toFixed(2));
  } else {
    form.money = parseFloat((a * b).toFixed(2));
  }

}


const onReset = () => {
  form.userAddress = '';
  form.year = '';
  form.month = '';
  form.wages = '';
  form.money = '';
  checked.checked1 = false;
  checked.checked2 = false;
  checked.checked3 = false;
  checked.checked4 = false;
  checked.checked5 = false;
  checked.checked6 = false;
  checked.checked7 = false;
  checked.checked8 = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { style: {"width":"100%"} }, {
      header: _withCtx(() => _cache[12] || (_cache[12] = [
        _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("span", { style: {"font-weight":"bold"} }, "离职补偿金预估(免费测算)")
        ], -1)
      ])),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "auto",
          style: {"max-width":"450px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "所在地区：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  placeholder: '请选择所在地区',
                  options: _unref(pcaTextArr),
                  modelValue: form.userAddress,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAddress) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "离职原因：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checked.checked1) = $event)),
                  label: "未签合同"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked2,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checked.checked2) = $event)),
                  label: "未缴纳社保"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked3,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checked.checked3) = $event)),
                  label: "欠薪，既成事实降薪"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked4,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checked.checked4) = $event)),
                  label: "不提供劳动条件"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked5,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checked.checked5) = $event)),
                  label: "被书面解除劳动合同（违法）"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked6,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((checked.checked6) = $event)),
                  label: "合同到期不续签"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked7,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((checked.checked7) = $event)),
                  label: "三期女职工"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.checked8,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checked.checked8) = $event)),
                  label: "被迫离职"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "该公司工作时长：" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_input, {
                      modelValue: form.year,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.year) = $event)),
                      style: {"max-width":"200px"},
                      placeholder: "请输入工作年数"
                    }, {
                      append: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("年")
                      ])),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_input, {
                      modelValue: form.month,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.month) = $event)),
                      style: {"max-width":"200px"},
                      placeholder: "请输入工作月数"
                    }, {
                      append: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("月")
                      ])),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "月平均收入：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  onInput: _ctx.handleInput,
                  modelValue: form.wages,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.wages) = $event)),
                  style: {"width":"240px"},
                  placeholder: "请输入月平均薪酬"
                }, null, 8, ["onInput", "modelValue"]),
                _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"color":"#c0c4cc"} }, "过去十二个月在当前公司所获薪酬总额的月平均值", -1))
              ]),
              _: 1
            }),
            (form.money)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[16] || (_cache[16] = _createTextVNode("可领取金额：")),
                    _createElementVNode("span", null, _toDisplayString(form.money), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("计算")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(ElButton), { onClick: onReset }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})